import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=37885189&scoped=true&"
import script from "./Bet.vue?vue&type=script&lang=ts&"
export * from "./Bet.vue?vue&type=script&lang=ts&"
import style0 from "./Bet.vue?vue&type=style&index=0&id=37885189&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37885189",
  null
  
)

export default component.exports